import {AxiosResponse} from 'axios'
import {PersonTagRequest, UntagResponse} from './types'
import {HttpInstance} from '../createHttpInstance'

export interface UntagPhoto<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const untagPhoto: UntagPhoto<PersonTagRequest, UntagResponse> = (
  http,
  params,
) => {
  const {ClientID, PersonID, PhotoID} = params

  const path = '/v1/photos/{photoid}/person-tags/{personid}'
    .replace('{personid}', PersonID.toString())
    .replace('{photoid}', PhotoID.toString())

  return http.request<UntagResponse>({
    method: 'DELETE',
    url: `${path}?clientid=${ClientID}`,
  })
}
